var app = {
	header: {
		build: "ビルド",
		closeButton: "閉じる",
		copyrightLabel: "著作権",
		helpLabel: "ヘルプ",
		legalNoticeLabel: "法的通知",
		logoutButton: "ログアウト",
		menuLabel: "メニュー",
		module: "モジュール",
		noUserDataLabel: "ユーザーデータは利用できません",
		notificationsLabel: "通知",
		privacyPolicyLabel: "プライバシーポリシー",
		serviceAppLabel: "サービスアプリ",
		settingsLabel: "設定",
		shopLabel: "ショップ",
		smartFactorySuiteLabel: "スマートファクトリースイート",
		softwareInformation: "ソフトウェア情報",
		userLabel: "プロフィール",
		userProfileLinkText: "ユーザープロフィール",
		version: "バージョン"
	}
};
var contentLoadingError = "コンテンツを読み込めませんでした";
var dashboard = {
	cancel: {
		button: "キャンセル"
	},
	edit: {
		button: "編集"
	},
	reset: {
		button: "リセット"
	},
	save: {
		button: "保存"
	},
	share: {
		button: "共有"
	}
};
var filter = {
	clear: "フィルターをリセット",
	clearAll: "すべてのフィルターをリセット"
};
var locationMap = {
	locationLink: {
		label: "場所に移動"
	}
};
var machineDiscontinuation = {
	linkText: "詳細を知る"
};
var notifications = {
	button: {
		loadMore: "さらに読み込む"
	},
	date: {
		lastMonth: "先月",
		lastWeek: "先週",
		older: "以前",
		thisMonth: "今月",
		thisWeek: "今週",
		today: "今日",
		yesterday: "昨日"
	},
	error: {
		general: "現在、通知を表示できません。後でもう一度お試しください。",
		unauthorized: "通知を表示するにはサインインしてください"
	},
	info: {
		activateSettings: "通知を受け取るには、設定で有効にしてください",
		noNotification: "現在、メッセージはありません。"
	},
	title: "通知"
};
var results = {
	counter: {
		label: "件の結果"
	}
};
var scrollToTop = {
	label: "トップにスクロール"
};
var slider = {
	nextButton: {
		label: "次のスライド"
	},
	paginationBullet: {
		label: "スライド"
	},
	prevButton: {
		label: "前のスライド"
	}
};
var sorting = {
	ascending: "昇順",
	descending: "降順"
};
var userAccount = {
	address: {
		label: "郵送先住所"
	},
	email: {
		label: "メール"
	},
	language: {
		label: "言語",
		locale: "ロケール",
		select: "言語を選択",
		settings: "言語設定"
	},
	loggedOut: {
		message: "ログインしていません"
	},
	login: {
		button: "サインイン"
	},
	name: {
		label: "名前"
	},
	phone: {
		label: "電話"
	}
};
var widget = {
	filter: {
		machine: {
			filter: "機械をフィルタリング",
			label: "機械",
			option: {
				all: "すべての機械"
			},
			select: "機械を選択"
		},
		period: {
			label: "期間",
			option: {
				currentMonth: "今月",
				currentWeek: "今週",
				lastMonth: "先月",
				lastWeek: "先週",
				today: "今日",
				yesterday: "昨日"
			}
		}
	}
};
var widgetRegistry = {
	allWidgets: {
		label: "私のウィジェット"
	},
	noDescriptionAvailable: "説明はありません。",
	widget: {
		SampleMyMachines: {
			title: "私の機械"
		},
		SampleMyServiceCalls: {
			title: "サービスコール"
		},
		SampleMyTrackingList: {
			title: "トラッキングリスト"
		},
		SampleMyUserAccount: {
			title: "私のプロフィール"
		},
		SampleOperationalStatesChart: {
			title: "運用状態"
		},
		SampleWidgetFilter: {
			title: "フィルター設定"
		},
		SampleWorkloadBalanceChart: {
			title: "ワークロードバランス"
		}
	}
};
var translation = {
	app: app,
	contentLoadingError: contentLoadingError,
	dashboard: dashboard,
	filter: filter,
	locationMap: locationMap,
	machineDiscontinuation: machineDiscontinuation,
	notifications: notifications,
	results: results,
	scrollToTop: scrollToTop,
	slider: slider,
	sorting: sorting,
	userAccount: userAccount,
	widget: widget,
	widgetRegistry: widgetRegistry
};

export { app, contentLoadingError, dashboard, translation as default, filter, locationMap, machineDiscontinuation, notifications, results, scrollToTop, slider, sorting, userAccount, widget, widgetRegistry };
